'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./ListDropPreview.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListDropPreview = function ListDropPreview(props) {
  return _react2.default.createElement(
    'div',
    { className: 'ListDropPreview' },
    _react2.default.createElement('div', { className: 'preview-line' })
  );
};

exports.default = ListDropPreview;


//////////////////
// WEBPACK FOOTER
// ./src/client/list/ListDropPreview.js
// module id = 2033
// module chunks = 0